import { createSlice, PayloadAction, Dispatch } from '@reduxjs/toolkit';

interface AlertState {
    isShow: boolean;
    type: "success" | "danger" | "warning" | "info";
    title: string;
    content: string;
}

const initialState: AlertState = {
    isShow: false,
    type: "info",
    title: "",
    content: "",
};

const AlertSlice = createSlice({
    name: 'AlertSlice',
    initialState,
    reducers: {
        showAlert: (state, action: PayloadAction<{ type: AlertState["type"]; title: string; content: string }>) => {
            state.isShow = true;
            state.type = action.payload.type;
            state.title = action.payload.title;
            state.content = action.payload.content;
        },
        hideAlert: (state) => {
            state.isShow = false;
        },
        clearState: (state) => {
            return initialState;
        }
    },
});

export const { showAlert, hideAlert } = AlertSlice.actions;
export default AlertSlice.reducer;

export const showAlertWithTimeout =
    (type: AlertState["type"], title: string, content: string) =>
        (dispatch: Dispatch) => {
            dispatch(showAlert({ type, title, content }));

            setTimeout(() => {
                dispatch(hideAlert());
            }, 3000); // Ẩn sau 3 giây
        };

